import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'

import Paper from '@material-ui/core/Paper'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'

import GlobalLoading from 'components/system/GlobalLoading'
import SideMenu from 'components/layout/SideMenu'
import AppBarMenu from 'components/layout/AppBarMenu'

import settings from 'settings'
import selectors from 'store/selectors'
import routerActions from 'store/modules/router'
import projectActions from 'store/modules/project'
import userActions from 'store/modules/user'

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%'
  },
  appbar: {
    zIndex: 1000,
    width: '100%',
    position: 'fixed',
    flexGrow: 1,
    flex: 1,
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
  },
  flex: {
    flex: 1,
  },
  appBarShadow: {
    position: 'absolute',
    top: '62px',
    width: '100%',
    height: '0px',
    zIndex: 1000,
    //backgroundColor: '#ff0000',
    boxShadow: '0px 2px 5px 5px rgba(0,0,0,0.2)',
  },
  content: {
    paddingTop: '64px',
    height: '100%',
  }
}))

const Layout = ({
  children,
}) => {

  const classes = useStyles()
  const dispatch = useDispatch()

  const title = settings.title
  const loggedIn = useSelector(selectors.user.loggedIn)
  const user = useSelector(selectors.user.data)
  const projects = useSelector(selectors.project.collection.list)
  const activeProject = useSelector(selectors.project.activeProject)
  const globalLoading = useSelector(state => state.network.globalLoading)

  const createProject = () => dispatch(routerActions.navigateTo('project.edit', { id: 'new' }))
  const setActiveProject = (id) => dispatch(projectActions.setActiveProject(id))
  const openPage = (name, params) => dispatch(routerActions.navigateTo(name, params))
  const logout = () => dispatch(userActions.logout())

  const sideMenuItems = settings.sideMenu({
    loggedIn,
    activeProject,
    handlers: {
      logout,
    },
  })

  const appBarMenuItems = settings.appbarMenu({
    loggedIn,
    activeProject,
    handlers: {
      logout,
    },
  })

  return (
    <div className={ classes.root }>
      <div className={ classes.appbar }>
        <AppBar position="static" elevation={ 0 }>
          <Toolbar>
            <SideMenu 
              user={ user }
              items={ sideMenuItems }
              openPage={ openPage }
            />
            <Typography 
              variant="h6" 
              color="inherit" 
              className={ classes.flex }
            >
              { title }
              {
                activeProject ? 
                  ` : ${activeProject.name}` :
                  ''
              }
            </Typography>
            <AppBarMenu
              user={ user }
              items={ appBarMenuItems }
              openPage={ openPage }
              projects={ projects }
              activeProject={ activeProject }
              createProject={ createProject }
              setActiveProject={ setActiveProject }
            />
          </Toolbar>
        </AppBar>
        
      </div>
      <div className={ classes.content }>
        { children }
      </div>
      <GlobalLoading
        loading={ globalLoading }
      />
    </div>
  )
}

export default Layout